import {useLocation} from '@reach/router'
import QueryString from 'query-string'

export const useQueryParams = () => {
	const location = useLocation()
	return QueryString.parse(location.search)
}

export default useQueryParams
